import { Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'
import loadable from '@loadable/component'

import Loading from '../components/display/Loading'

const VoucherCreate = loadable(() =>
  import(/* webpackChunkName: "vouchers-create" */ '../pages/vouchers/Create')
)
const VoucherPay = loadable(() =>
  import(
    /* webpackChunkName: "vouchers-create" */ '../pages/vouchers/Pay/index'
  )
)
const VoucherCreateSuccess = loadable(() =>
  import(/* webpackChunkName: "vouchers-create" */ '../pages/vouchers/Success')
)

// Small client-only pages share a `client-misc` chunk to avoid manifest
// bloat without leaving them in main.
const UserProfile = loadable(() =>
  import(/* webpackChunkName: "client-misc" */ '../pages/user/UserProfile')
)
const Bucketlist = loadable(() =>
  import(/* webpackChunkName: "client-misc" */ '../pages/bucketlist')
)
const Referral = loadable(() =>
  import(/* webpackChunkName: "client-misc" */ '../pages/referral')
)

const UserRoutes = loadable(
  () => import(/* webpackChunkName: "user" */ './UserRoutes'),
  { fallback: <Loading /> }
)
const BookingRoutes = loadable(
  () => import(/* webpackChunkName: "bookings" */ './BookingRoutes'),
  { fallback: <Loading /> }
)

export default (
  <Fragment>
    <Route exact path="/vouchers/create" component={VoucherCreate} />
    <Route path="/vouchers/:voucherId/pay" component={VoucherPay} />
    <Route
      path="/vouchers/:voucherId/success"
      component={VoucherCreateSuccess}
    />
    <Route path="/users/:userId" component={UserProfile} />
    <Route path="/bucket-lists/:token" component={Bucketlist} />
    <Route exact path="/referrals/:token" component={Referral} />
    <Switch>
      <Route path="/my/bookings" component={BookingRoutes} />
      <Route path="/my/" component={UserRoutes} />
    </Switch>
  </Fragment>
)
